import {useReportingResource} from '@/hooks/useReportingResource';
import {downloadFile} from '@/lib/api';
import NativeWordHistory from './NativeWordHistory';
import CompletionAssessmentForm from './CompletionAssessmentForm';
export const ASSESSMENT_FIELDS=[
 ['identification','Identitas setiap pakar / auditor lain dan dasar penggunaan'],
 ['competence','Evaluasi kompetensi setiap pihak'],
 ['capability','Evaluasi kapabilitas setiap pihak'],
 ['objectivity','Evaluasi objektivitas dan hubungan yang relevan'],
 ['scope_of_work','Lingkup, tanggung jawab dan komunikasi yang disepakati'],
 ['work_evaluation','Evaluasi pekerjaan, metode, asumsi, temuan dan tindak lanjut'],
 ['conclusion','Kesimpulan auditor atas pekerjaan aktual'],
];
export default function ExpertAssessment({id}){
 const resource=useReportingResource(id,'expert-assessment'),evidence=useReportingResource(id,'evidence');
 const components=useReportingResource(id,'group/components');
 if(resource.error)return <p role="alert">{resource.error}</p>;
 if(!resource.data)return <p>Memuat evaluasi pakar / auditor lain…</p>;
 const data=resource.data;
 return <section><p className="text-xs mb-3">Dokumentasikan evaluasi setiap pihak yang digunakan, termasuk identitas dan sumber pendukung. Penugasan komponen bukan bukti kompetensi atau reviu. Jika tidak digunakan, dokumentasikan dasar dan relevansi setiap area.</p>
 {(evidence.error||components.error)&&<p role="alert">{evidence.error||components.error}</p>}
 <CompletionAssessmentForm key={`${id}:${data.mutation_version||0}`} id={id} data={data} fields={ASSESSMENT_FIELDS}
 title="C160 — Evaluasi Pakar / Auditor Lain" endpoint={`/engagements/${id}/expert-assessment`} prefix="expert-assessment" testId="expert-assessment-form"
 evidence={evidence.data||[]} reloadEvidence={evidence.reload} reloadAssessment={resource.reload} mutate={resource.mutate} busy={resource.busy}
 classifications={['Under assessment','Experts used','Other auditors used','Experts and other auditors used','No experts or other auditors used']} choiceField="scope_status" choiceLabel="Status penggunaan pakar / auditor lain"
 extraWork={{scope_status:data.scope_status||'Under assessment',component_ids:data.component_ids||[]}}
 referenceGroups={[
 {key:'component_ids',label:'Komponen terkait',options:(Array.isArray(components.data)?components.data:[]).map(p=>({value:p.id,label:p.entity||p.id}))},
 ]}/>
 <button type="button" className="border rounded p-2 text-xs" disabled={!data.id} onClick={()=>downloadFile(`/engagements/${id}/expert-assessment/export/docx`,'C160-working-copy.docx')}>Ekspor Word C160</button>
 <NativeWordHistory id={id} exportType="C160" recordId={data.id}/>
 </section>;
}
